import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';

// Crypto Redux States
import { cargoReleaseCreateTypes } from './actionTypes';
import { getCargoReleaseOptionsSuccess,getCargoReleaseOptionsFail, getFiltersItemAggregationSuccess, getFiltersItemAggregationFail, getItemsAggregation, getItemsAggregationSuccess, getItemsAggregationFail, getAdressByEntitySuccess, getAdressByEntityFail } from './actions';
import Swal from 'sweetalert2';


let controller = new AbortController();
let signal = controller.signal;




export const fetchList = async () => {
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }
    const query = `query {
  GetFiltersCreateCR(userId: ${user.id || ""}) {
  	CargoRelaseNumber
    ReleaseList {
      name
    }
    BillingClientList {
      name
    }
    CarrierList {
      id
      name
    }
  }
}`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    return response.data.GetFiltersCreateCR;
};

function* fetchListSaga() {
    try {
        const response: Promise<any> = yield call(fetchList);
        yield put(getCargoReleaseOptionsSuccess(response));
    } catch (error) {
        yield put(getCargoReleaseOptionsFail(error));
    }
}

//--------------------------create---------------------------------------


export const CreateCR = async (cargoRelease:any) => {
    const {releaseDate,releasedTo,billingClient,carrier,purchaseOrderNumber,trackingNumber,proNumber,driver,driverLicense,notes,items,number,street,city,state,zipCode,description,country,contactPhone}= cargoRelease
    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

  const transformedItemsString = items.map((item:any) => `
    {
      PartNumber: "${item.CLPartNumber}",
      Pieces: ${item.pieces},
      GUID: "${item.CLGUID}"
    }
  `).join(',');
  
  const itemsString = items.length > 0 ? `
    Items: [${transformedItemsString}]
  ` : '';


    const query = `
mutation {
    CreateCargoRelease(CargoRelease: {
      userId: ${user.id},
      ReleaseDate: "${releaseDate}",
      Number: "${number}",
      ReleasedToName: "${releasedTo}",
      BillingClientName: "${billingClient}",
      CarrierName:"${carrier}",
      SupplierPONumber: "${purchaseOrderNumber}",
      CarrierTrackingNumber:"${trackingNumber}",
      CarrierPRONumber: "${proNumber}",
      DriverName: "${driver}"
      DriverLicenseNumber: "${driverLicense}"
      Notes: "${notes}",
      ReleasedToAddress:{
        Street: "${street}",
        City:"${city}",
        State: "${state}",
        ZipCode:"${zipCode}",
        Description:"${description}",
        ContactPhone: "${contactPhone}",
        Country:{
          Code:"",
          text: "${country}"
				}
      }
      
      ${itemsString}
  }){
      resultXML
      message
      success
    }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());

    const responseData = response.data.CreateCargoRelease;

    if(responseData.success){
      Swal.fire('successful creation', responseData.message, 'success')
    }else{
      Swal.fire('Error creation', responseData.message, 'error')
    }

    return responseData;
};

function* CreateCRSaga(action:any) {
  const {form,history} = action.payload
    try {
        const response: Promise<any> = yield call(CreateCR,form);
        yield put(getCargoReleaseOptionsSuccess(response));
        history.push('/CRList', { parametro: true });
    } catch (error) {
        yield put(getCargoReleaseOptionsFail(error));
    }
}


//-------------------------------------get filtros------------------------------------------

export const GetFilterItemsAggregation = async () => {

  const path = url.API_URL;
  // const getAuthUser = localStorage.getItem('authUser');
  // let user;
  // if (getAuthUser) {
  //     user = JSON.parse(getAuthUser);
  // }

  const query = `query {
  GetCommodityFilters {
    filterItems {
      text
      dataField
      showInFilters
      data {
        id
        name
      }
    }
  }
}`;

  const response = await fetch(path, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({
          query,
      }),
  }).then((res) => res.json());

  return response.data.GetCommodityFilters;
};

function* GetFilterItemsAggregationSagaSaga() {
  try {
      const response: Promise<any> = yield call(GetFilterItemsAggregation);
      yield put(getFiltersItemAggregationSuccess(response));
  } catch (error) {
      yield put(getFiltersItemAggregationFail(error));
  }
}

//-----------------------------------GET ITEMS------------------------------


export const fetchCommodity = async (data: any) => {
  const { from, to, order, dynamicFilter } = data.form;
  const { sizePerPage, page } = data.pagination;

  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
      user = JSON.parse(getAuthUser);
  }

  const query = `query {
  GetComodityList(Comodity: {
    userId: ${user.id || ''},
    initial_date: "${from || ''}",
    final_date: "${to || ''}",
    order : "{'CLEntryDate' : 'ASC'}",
    CLStatus: "ON HAND%%$_AND",${dynamicFilter}
    }, Pagination:{
      sizePage:${sizePerPage},
      actualPage:${page}
    })
    {
      comodityData{
          CRclientId
        CRCreatedOn
        CRReleaseDate
        CRNumber
        CRCreatedByName
        CRVersion
        CRIssuedByName
        CRCreatorNetworkID
        CRTotalPieces
        CRTotalWeight
        CRTotalVolume
        CRTotalVolumeWeight
        CRTotalValue
        CRReleasedToName
        CRStatus
        CRHasAttachments
        CRIsOnline
        CRIsLiquidated
        CRCFaverage_days_to_prepare
        CRCFaverage_days_to_release
        CRCFwh_location
        CRCFcr_cartons
        CRCFcr_pallets
        CRGUID      
        CRBillingClientName
        CRBillingClientGUID
        CRReleasedToGUID
        CRcustomFields {
          name
          value
          internalName
        } 
        CRVolumeWeightUnit
        CRLengthUnit
        CRVolumeUnit
        CRWeightUnit
        PONumber
        POCreatedOn
        POCreatedByName
        POVersion
        POStatus
        POBuyerName
        POSellerName
        POTotalAmountInCurrency
        POItemsAmountInCurrency
        POChargesAmountInCurrency
        POTaxAmountInCurrency
        POTotalAmount
        POItemsAmount
        POChargesAmount
        POTaxAmount
        POTotalWeight
        POTotalVolume
        POTotalTradeDiscount
        POTotalTradeDiscountInCurrency
        POExchangeRate
        POCreatorNetworkID
        POTotalPieces
        POIsAcceptedBySeller
        POIsOnline
        POIsCancelled

        POGUID
        POCFstatus_gwae
        POCFbrand
        POCFcommodity_type
        POcreatedAt
        POupdatedAt
        POBillingClientName
        POBillingClientGUID
        POBuyerGUID
        POSellerGUID
        POApprovedByName
        PODocumentTemplateName
        PONotes
        POPaymentTerms
        POReferenceNumber
        POIsOnlineTransaction    
        POIsTrackingEmailSent          
        POLastLineID
        POLengthPrecision    
        POLengthUnit    
        POVolumePrecision      
        POVolumeUnit      
        POVolumeWeightPrecision        
        POWeightPrecision    
        POWeightUnit
        POVolumeWeightUnit
        POJOBNumber
        POcustomFields {
          name
          value
          internalName
        } 
        WRclientId
        WRCreatedOn
        WRNumber
        WRCreatedByName
        WRVersion
        WRModeOfTransportCode
        WRIssuedByName
        WRShipperName
        WRConsigneeName
        WRCreatorNetworkID
        WRTotalPieces
        WRTotalWeight
        WRTotalVolume
        WRTotalVolumeWeight
        WRLengthUnit
        WRVolumeUnit
        WRWeightUnit
        WRVolumeWeightUnit
        WRChargeableWeight
        WRTotalValue
        WRStatus
        WRHasAttachments
        WRLastItemID
        WRIsOnline
        WRIsLiquidated
        WRGUID
        WRCFstatus_gwae
        WRCFwh_location
        WRcreatedAt
        WRupdatedAt
        WRBillingClientName
        WRBillingClientGUID
        WRDestinationAgentName
        WRcustomFields {
          name
          value
          internalName
        } 
        clientId
        CLVersion
        CLStatus
        CLWarehouseReceiptGUID
        CLCargoReleaseGUID
        CLPackageName
        CLLocationCode
        CLWarehouseReceiptNumber
        CLCargoReleaseNumber
        CLOutDate
        CLPieces
        CLPieceQuantity
        CLWHRItemID
        CLOrderIndex
        CLContainedPiecesWeightIncluded
        CLIsContainer
        CLIsSummarized
        CLIncludeInSED
        CLIsPallet
        CLIsOverstock
        CLNotLoaded
        CLInTask
        CLDescription
        CLPartNumber
        CLUpItemGUID
        CLOutShipmentGUID
        CLOutMasterWayBillNumber
        CLOutHouseWayBillNumber
        CLLastReceptionNetworkID
        CLShipmentType
        CLSupplierPONumber
        CLPurchaseOrderGUID
        CLSalesOrderGUID
        CLSOLineID
        CLSalesOrderNumber
        CLEntryDate
        CLExpirationDate
        CLLotNumber
        CLInMasterShipmentGUID
        CLOutMasterShipmentGUID
        CLWArehouse
        CLGUID
        CLcreatedAt
        CLupdatedAt
        CLmodel
        CLLengthUnit
        CLHeightUnit
        CLWidthUnit
        CLWeightUnit
        CLVolumeUnit
        CLVolumeWeightUnit
        CLLength
        CLHeight
        CLWidth
        CLWeight
        CLVolume
        CLVolumeWeight
        SOclientId
        SONumber
        SOCreatedOn
        SOCreatedByName
        SOVersion
        SOStatus
        SOShippingDate
        SOBuyerName
        SOSellerName
        SOPaymentTerms
        SOExchangeRate
        SOCreatorNetworkID
        SOTotalPieces
        SOTotalAmountInCurrency
        SOIsAcceptedBySeller
        SOIsOnline
        SOIsCancelled
        SOCFstatus_gwae
        SOCFwh_location
        SOCFbrand
        SOCFcommodity_type
        SOGUID
        SOcreatedAt
        SOupdatedAt
        SOBillingClientName
        SOBillingClientGUID
        SOBuyerGUID
        SOSellerGUID
        SOLengthUnit
        SOVolumeUnit
        SOVolumeWeightUnit
        SOWeightUnit
        SOcustomFields {
          name
          value
          internalName
        } 
        }
      CountItems
    }
}`;

  const response = await fetch(path, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({
          query,
      }),
      signal,
  }).then((res) => res.json());
  return response.data.GetComodityList;
};

export const cancelFetchItemAggregation = () => {
  controller.abort(); // Esto cancelará la solicitud
  controller = new AbortController(); // Restablecer el controlador para futuras solicitudes
  signal = controller.signal; // Actualizar la señal para futuras solicitudes
};

function* fetchCommoditySaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchCommodity, data.payload);
        yield put(getItemsAggregationSuccess(response));
    } catch (error) {
        yield put(getItemsAggregationFail(error));
    }
}



//-----------------------------------GET ADDRESS------------------------------


export const fetchADDRESS = async (Entity: any) => {

  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
      user = JSON.parse(getAuthUser);
  }

  const query = `query{
  	GetAddressByEntityName(Entity: {
      userId:${user.id || ''},
      entityName: "${Entity}"
    }){
      name
      address_Description
      address_Street
      address_City
      address_State
      address_ZipCode
      address_Country
      address_ContactPhone

  }
}`;

  const response = await fetch(path, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({
          query,
      }),
      signal,
  }).then((res) => res.json());
  return response.data.GetAddressByEntityName;
};


function* fetchADDRESSSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchADDRESS, data.payload);
        yield put(getAdressByEntitySuccess(response));
    } catch (error) {
        yield put(getAdressByEntityFail(error));
    }
}


function* cargoReleaseCreationSaga() {
    yield takeLatest(cargoReleaseCreateTypes.GET_FiltersCreateCR, fetchListSaga);
    yield takeLatest(cargoReleaseCreateTypes.CREATE_CR, CreateCRSaga);
    yield takeLatest(cargoReleaseCreateTypes.GET_FiltersListItemAggregation, GetFilterItemsAggregationSagaSaga);
    yield takeLatest(cargoReleaseCreateTypes.GET_COMMODITY_DEFINITIONS, fetchCommoditySaga);
    yield takeLatest(cargoReleaseCreateTypes.GET_ADDRESS_BY_ENTITY_NAME, fetchADDRESSSaga);
}

export default cargoReleaseCreationSaga;
